var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gamedemo_page"},[_c('div',{staticClass:"active_fixed_btn"},[_c('div',{staticClass:"fix_btn",on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("测试跳转")])])])}
var staticRenderFns = []

export { render, staticRenderFns }